module.exports = __webpack_public_path__ + "img/image1.98b52502.jpg";